// @flow
import * as Sentry from '@sentry/browser';
import { BrowserTracing } from '@sentry/tracing';
// $FlowFixMe
import Settings from '../config/settings.js.erb';

const railsEnv = Settings.app.railsEnv;
const prodAllowUrls = [
  /^https:\/\/fundoor\.com.*$/,
  /^https:\/\/mufg-fundoor\.com.*$/,
];
const otherAllowUrls = [
  /^https:\/\/.+.fundoor\.com.*$/,
  /^https:\/\/.+.mufg-fundoor\.com.*$/,
];
if (railsEnv !== 'development' && railsEnv !== 'test') {
  Sentry.init({
    dsn:
      'https://fcb3d29058e94b74a25bde91fd1da5b1@o4504049689952256.ingest.sentry.io/4504049692311552',
    environment: railsEnv,
    integrations: [new BrowserTracing()],
    debug: railsEnv === 'development',
    // https://docs.sentry.io/platforms/javascript/configuration/filtering/#decluttering-sentry
    allowUrls:
      railsEnv === 'production' || railsEnv === 'mufg_production'
        ? prodAllowUrls
        : otherAllowUrls,
  });
}
